module.exports = __webpack_public_path__ + "static/img/lines.99dc68d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/generateQrCode/lines.png
// module id = ktcb
// module chunks = 0